import { CircularProgress, Grid, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Item from './Item.js'

const SelectTeam = ({onSelect, filter, selected, items, match}) => {

    return (
        match ? <Stack spacing={2} >
                        <Item selected={selected} onSelect={onSelect} value={`${match.homeTeam.name.toUpperCase()}`} id={match.homeTeam._id}/>
                        <Item selected={selected} onSelect={onSelect} value={`${match.awayTeam.name.toUpperCase()}`} id={match.awayTeam._id}/>
                        {items && items.map(i => <Item selected={selected} onSelect={onSelect} value={`${i.name.toUpperCase()}`} id={i.id}/>)}
                    </Stack> : <CircularProgress/>
    )

}

export default SelectTeam